import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section data-testid="page-404" className="border-b border-slate-200">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-24 lg:py-32 text-center">
        <div className="mono text-[10px] tracking-[0.22em] uppercase text-topo">404 · Sheet not found</div>
        <h1 className="display mt-3 text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tighter text-slate-900">
          This drawing isn't <span className="text-emerald-700">on file</span>.
        </h1>
        <p className="mt-4 text-slate-600">The page you're looking for has been moved, archived, or never existed.</p>
        <Link to="/" data-testid="404-back-home" className="mt-7 inline-flex items-center gap-2 rounded-sm bg-orange-survey hover:bg-orange-survey-dark text-white text-sm font-semibold px-5 py-3">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
      </div>
    </section>
  );
}
